<!--联系我们-->
<template>
  <div class="content_width_box">
      <div class="content_title">
        <div class="title_left_h2">{{ $t('investor.contactUs.title') }}</div>
      </div>
      <div class="content_list_layout">
          <div class="contact_div">
            <div class="contact_title">投资者关系部门-香港</div>
            <div class="contact_text">电话: (852) 24050088 (座机)</div>
            <div class="contact_text">邮箱: ir@kingsoft.com</div>
            <div class="contact_text">地址: 香港九龙尖沙咀海港城港威大厦第5座32楼3208室</div>
          </div>
          <div class="contact_div">
            <div class="contact_title">投资者关系部门-北京</div>
            <div class="contact_text">电话: (86) 10 82325515 (直线) &nbsp;&nbsp;&nbsp;&nbsp;(86) 10 82334488 (分机 6650)</div>
            <div class="contact_text">传真: (86) 10 82325655</div>
            <div class="contact_text">邮箱: ir@kingsoft.com</div>
            <div class="contact_text">地址: 北京市海淀区西二旗中路33号 小米科技园D栋</div>
            <div class="contact_text">邮编: 100085</div>
          </div>
          <div class="contact_div">
            <div class="contact_title">北京金山</div>
            <div class="contact_text">电话: (86) 10 62927777</div>
            <div class="contact_text">传真: (86) 10 82325655</div>
            <div class="contact_text">地址: 北京市海淀区西二旗中路33号 小米科技园D栋</div>
            <div class="contact_text">邮编: 100085</div>
          </div>
        </div>

    </div>
</template>

<script>
export default {
  name: 'investorContactUs',
  props: {},
  data() {
    return {}
  }
}
</script>
